import z from "zod";

export const MergeTagChildrenPropertiesSchema = z.object({
  value: z.string(),
  text: z.string(),
  label: z.string(),
  type: z.enum(["image", "button", "number", "text"]).optional(),
});

export const MergeTagsSchema = z.object({
  value: z.string(),
  text: z.string(),
  label: z.string(),
  defaultValue: z.string().optional(),
  parentPath: z.string().optional(),
  childrenProperties: z
    .array(MergeTagChildrenPropertiesSchema)
    .optional()
    .nullable(),
  suggestions: z.array(z.string()).optional().nullable(),
});

const baseMergeTagGroupSchema = z.object({
  name: z.string(),
});

export type MergeTagGroup = z.infer<typeof baseMergeTagGroupSchema> & {
  items: (MergeTagGroup | z.infer<typeof MergeTagsSchema>)[];
};

export const MergeTagGroupSchema: z.ZodType<MergeTagGroup> =
  baseMergeTagGroupSchema.extend({
    name: z.string(),
    items: z.array(MergeTagsSchema.or(z.lazy(() => MergeTagGroupSchema))),
  });

export const MergeTagsArraySchema = z
  .union([MergeTagsSchema, MergeTagGroupSchema])
  .array();

export const SmartMergeTagsPattern = z.object({
  regex: z.string(),
  label: z.string(),
});

export const SmartMergeTagsSyntax = z.object({
  start: z.string(),
  end: z.string(),
});

export const SmartMergeTagsSchema = z.object({
  enabled: z.boolean(),
  patterns: z.record(z.string(), SmartMergeTagsPattern).optional(),
  syntax: SmartMergeTagsSyntax.optional(),
});

export type IMergeTag = z.infer<typeof MergeTagsSchema>;
export type IMergeTagGroup = z.infer<typeof MergeTagGroupSchema>;
export type IMergeTagArray = z.infer<typeof MergeTagsArraySchema>;
export type ISmartMergeTag = z.infer<typeof SmartMergeTagsSchema>;
